import { Controller } from "@hotwired/stimulus"

// Location-mode picker on the meeting form (mirrors the bidding
// module's pre-bid scheduling):
//   - Virtual Only → show the video section, hide the on-site address
//   - On-Site      → show the on-site address, hide video
//   - Both         → show both
//
// The on-site section defaults to the project address with a
// "Set different location" link that reveals a custom address field;
// a "Use project address" link reverts it.
export default class extends Controller {
  static targets = [
    "mode",
    "onsiteSection",
    "virtualSection",
    "useProjectAddr",
    "customLocation",
    "locationInput",
    "useCustomVideo",
    "customVideo",
    "videoInput"
  ]

  connect() {
    this._applyMode()
  }

  modeChanged() {
    this._applyMode()
  }

  showCustomLocation(event) {
    event.preventDefault()
    if (this.hasUseProjectAddrTarget) this.useProjectAddrTarget.classList.add("hidden")
    if (this.hasCustomLocationTarget) {
      this.customLocationTarget.classList.remove("hidden")
      if (this.hasLocationInputTarget) this.locationInputTarget.focus()
    }
  }

  useProjectAddress(event) {
    event.preventDefault()
    if (this.hasLocationInputTarget) this.locationInputTarget.value = ""
    if (this.hasCustomLocationTarget) this.customLocationTarget.classList.add("hidden")
    if (this.hasUseProjectAddrTarget) this.useProjectAddrTarget.classList.remove("hidden")
  }

  // Reveal the manual video-link field. Most users keep the automatic
  // Google Meet link, so this stays hidden behind a toggle.
  showCustomVideo(event) {
    event.preventDefault()
    if (this.hasUseCustomVideoTarget) this.useCustomVideoTarget.classList.add("hidden")
    if (this.hasCustomVideoTarget) {
      this.customVideoTarget.classList.remove("hidden")
      if (this.hasVideoInputTarget) this.videoInputTarget.focus()
    }
  }

  // Revert to the automatic Google Meet link — clear and hide the
  // custom field, bring back the toggle.
  useAutoVideo(event) {
    event.preventDefault()
    if (this.hasVideoInputTarget) this.videoInputTarget.value = ""
    if (this.hasCustomVideoTarget) this.customVideoTarget.classList.add("hidden")
    if (this.hasUseCustomVideoTarget) this.useCustomVideoTarget.classList.remove("hidden")
  }

  // ─── private ──────────────────────────────────────────────────

  _applyMode() {
    const mode = this.modeTarget.value
    const showOnsite = mode === "onsite" || mode === "both"
    const showVirtual = mode === "virtual" || mode === "both"
    if (this.hasOnsiteSectionTarget) {
      this.onsiteSectionTarget.classList.toggle("hidden", !showOnsite)
    }
    if (this.hasVirtualSectionTarget) {
      this.virtualSectionTarget.classList.toggle("hidden", !showVirtual)
    }
  }
}
